<template>
<v-container container--fluid grid-list-lg>
  <loading
    :active.sync="isLoading"
    :can-cancel="false"
    :is-full-page="true"
  />
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-text-field
            label="Instagram Post URL"
            placeholder="e.g. https://www.instagram.com/p/abcdefghijklm/"
            outlined
            color="yellow darken-3"
            v-model="igUrl"
          >
          </v-text-field>
          <div class="text-center">
            <v-btn rounded large
              color="primary"
              @click="analyse(igUrl)"
              >Analyse
            </v-btn>
            <button type="hidden" id="viewModalIdDisplay" data-toggle="modal" :data-target="viewModalIdDisplay"></button>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <h3>History</h3>
          <v-data-table          
            striped
            bordered
            hover
            responsive
            :headers="fields"
            :items="items"
          >
            <template v-slot:[`item.instagram`]="{ item }">
              <td>
                <a v-bind:href="item.instagram" target="_blank">{{item.instagram}}</a>
              </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <td>
              <v-btn
                @click="view(item)"
                small rounded
                >
                View
              </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- <div class="row">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="sm" align="center" />
          </div> -->
        </v-card-text>
      </v-card>
    </v-flex>
      <content-analysis-result-modal :modalId="contentAnalysisResultModal" :postData="postAnalytics"/>
  </v-layout>
</v-container>
</template>
<script>
import ContentAnalysisResultModal from './ContentAnalysisResultModal'
import analysisAPI from './contentAnalysisAPI'
import config from '../../../config'
 // Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'ContentAnalysis',
  components: {
    ContentAnalysisResultModal,
    Loading
  },
  data() {
    return {
      contentAnalysisResultModal: 'contentAnalysisResultModal',
      igUrl: '',
      postAnalytics: null,
      isLoading: false,
      histories: [],
      items: [],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          value: 'updatedAt',
          text: 'Date'
        },
        {
          value: 'instagram',
          text: 'Instagram Post'
        },
        {
          value: 'actions',
          text: 'Actions'
        }
      ]
    }
  },
  computed: {
    viewModalIdDisplay: function() {
      return '#' + this.contentAnalysisResultModal
    }
  },
  mounted: function() {
    this.getHistories()
    this.$nextTick(function () {
      $(document).trigger("resize"); // eslint-disable-line
      // recalculate the size for content-wrapper changes
    })
  },
  watch: {
    currentPage: function(newValue) {
      this.paginate()
    }
  },
  methods: {
    analyse(igUrl) {
      let shortCode = ''
      if (!igUrl) {
        this.$swal({
          title: 'Empty Post URL',
          text: 'Please Input a valid URL',
          type: 'error'
        })
        return
      } else {
        if (igUrl.indexOf('https://www.instagram.com/p/') !== -1) {
          let regex = config.regexPattern.instagram
          /**
           * Aung
           * Bug fixed on the second time view, Analyse button click
           * Added if(igUrl.match(regex)) to avoid return null from the regex.exec(igUrl)
           * comment out for if(searchShortCodes.lenght === 2) no longer needed
           */
          if (igUrl.match(regex)) {
            // console.log('!Is Match')
            let searchShortCodes = regex.exec(igUrl)
            shortCode = searchShortCodes[1]
          }
          // if (searchShortCodes.length === 2) {
          //   shortCode = searchShortCodes[1]
          // }
        }
        if (shortCode.trim().length === 0) {
          this.$swal({
            title: 'Error',
            text: 'Please Input a valid URL',
            type: 'error'
          })
        } else {
          this.isLoading = true
          analysisAPI
            .analyse(shortCode)
            .then(result => {
              this.postAnalytics = result.post_analytics
              document.getElementById('viewModalIdDisplay').click()
              this.isLoading = false
              this.getHistories()
            })
            .catch(error => {
              console.log(error)
              this.$swal({
                title: 'Error',
                text: 'Cannot found the post',
                type: 'error'
              })
              this.isLoading = false
            })
        }
      }
    },
    getHistories: function() {
      analysisAPI.getHistories().then((data) => {
        this.histories = data
        this.totalRows = this.histories.length
        this.paginate()
      })
    },
    paginate: function() {
      let start = (this.currentPage - 1) * this.perPage
      let end = start + this.perPage
      this.items = this.histories.slice(start, end)
    },
    view(item) {
      this.analyse(item.instagram)
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?59b0f222